'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_COUNTRY = 'us';

var LANG_TO_ISO2 = {
  de: 'de',
  en: 'us',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  it: 'it',
  ja: 'jp',
  nl: 'nl',
  sv: 'se'
};

exports.default = function () {
  var _I18n$locale$split = _I18n2.default.locale.split('-'),
      _I18n$locale$split2 = _slicedToArray(_I18n$locale$split, 2),
      lang = _I18n$locale$split2[0],
      country = _I18n$locale$split2[1];

  if (country) {
    return country;
  } else if (LANG_TO_ISO2[lang]) {
    return LANG_TO_ISO2[lang];
  }

  return DEFAULT_COUNTRY;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.245/js/utils/getCountryCodeFromLocale.js
// module id = 293
// module chunks = 0